import { RouteView } from '@/layouts';

const preferRouter = {
  path: '/prefer',
  name: 'Prefer',
  redirect: '/prefer/prefervip',
  component: RouteView,
  meta: {
    title: '会员管理',
    icon: 'iconVIP',
    roles: ['admin'],
  },
  children: [
    {
      path: 'prefervip',
      name: 'Prefervip',
      component: RouteView,
      redirect: '/prefer/prefervip/list',
      hideChildrenInMenu: true,
      meta: {
        title: '会员列表',
        icon: 'iconCustomermanagement',
        roles: ['admin'],
      },
      children: [
        {
          path: 'list',
          name: 'PreferList',
          component: () => import('@/views/prefer/preferlist/List'),
          meta: {
            icon: 'iconCustomermanagement',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'detail',
          name: 'PreferDetail',
          component: () => import('@/views/prefer/preferlist/Detail'),
          meta: {
            title: '会员详情',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'editor',
          name: 'PreferEditor',
          component: () => import('@/views/prefer/preferlist/Editor'),
          meta: {
            title: '编辑会员',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'add',
          name: 'PreferAdd',
          component: () => import('@/views/prefer/preferlist/Editor'),
          meta: {
            title: '新增会员',
            roles: ['admin'],
            hidden: true,
          },
        },
      ],
    },
    {
      path: 'preferconfig',
      name: 'PreferConfig',
      component: RouteView,
      redirect: '/prefer/preferconfig/list',
      hideChildrenInMenu: true,
      meta: {
        title: '会员卡配置',
        icon: 'iconcollection',
        roles: ['admin'],
      },
      children: [
        {
          path: 'list',
          name: 'PreferConfigList',
          component: () => import('@/views/prefer/preferconfig/List'),
          meta: {
            icon: 'iconCustomermanagement',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'add',
          name: 'preferConfigAdd',
          component: () => import('@/views/prefer/preferconfig/Add'),
          meta: {
            title: '会员卡添加',
            roles: ['admin'],
            hidden: true,
          },
        },
      ],
    },
  ],
};

export default preferRouter;
